import styled from 'styled-components';

const FlexContainer = styled.div`
    display: flex;
`
export default FlexContainer;


// WEBPACK FOOTER //
// ./src/components/UI/Layout/FlexContainer.js